(function ($) {

    $(document).ready(function () {

        if ($('.graph-rollover').length) {
            
            var item = $('.graph-rollover');

            item.on('mouseenter',function () {
                $('.graph-rollover.active').removeClass('active');
                $(this).addClass('active');
            });

            item.on('mouseleave', function () {
                $('.graph-rollover.active').removeClass('active');
            });
            
            item.on('click', function () {
                var link = $(this).data('link');

                if (link.length) {
                    window.location.href = link;
                }
            });

            if (window.location.href.indexOf("philanthropic-partners") > -1) {
                $("#philanthropic_rollover").addClass('current');
            } else if (window.location.href.indexOf("advisory-commitee") > -1) {
                $("#advisory_rollover").addClass('current');
            } else if (window.location.href.indexOf("design-team") > -1) {
                $("#design_rollover").addClass('current');
            } else if (window.location.href.indexOf("implementation-team-fit") > -1) {
                $("#FIT_rollover").addClass('current');
            } else if (window.location.href.indexOf("regional-connectors") > -1) {
                $("#regional_rollover").addClass('current');
            }
        }
    });

})(jQuery);


// WEBPACK FOOTER //
// ./src/js/custom/who_graphic.es6